import { useFeatureEntitlement } from "@/composables/use-feature-entitlement";

/**
 * Gate for the "compliancy" feature (evidence option, BPMN compliancy layer,
 * live dashboard evidence column).
 *
 * The feature is gated by the compliancy *subscription entitlement* — the single
 * source of truth. This ensures the option only appears when the Stek is actually
 * subscribed (see Billing & Subscription). (The legacy `stek.compliance_enabled`
 * flag has been removed.)
 */
export const useComplianceEntitlement = () => {
    const {
        isEnabled: complianceEnabled,
        isLoading: complianceLoading,
        unavailableReason: complianceUnavailableReason,
    } = useFeatureEntitlement("compliancy");
    return {
        complianceEnabled,
        // Exposed so a caller can tell "not entitled" from "not answered yet" —
        // `useLiveModeEntitlement` already does, and the Live nav entry needed it
        // to stop flickering enabled during the fetch. Compliance surfaces fail
        // closed while loading (they stay hidden), so the remaining difference is
        // cosmetic: they pop in when the answer lands. Whether a given surface
        // should show a placeholder instead is a per-surface design call, so the
        // consumers are left alone rather than changed blind.
        complianceLoading,
        complianceUnavailableReason,
    };
};
